// Static demo-mode fill-in data for TeamList.component.jsx.
// Shapes must match exactly what this view's own rendering expects:
//   - `companyOptions`: [{ value, label }] — fed straight into the Company
//     `Dropdown` (see @/components/Dropdown).
//   - the DataTable `value` rows (built from `tableRows`/`filteredRows` in
//     the real component): { teamId, teamName, memberCount, _loading }.
//
// There's only a single demo company (`demo-company`, "Meridian Labs") —
// matching the one profile used everywhere else in demo mode, e.g.
// src/store/Auth/Auth.reducer.js's DEMO_PROFILE.
//
// Exactly 3 teams, matching the 12-person roster in
// src/views/EmployeeList/EmployeeList.demoData.js (the single source of
// truth for company/department/roster data). memberCount is each team's
// activeTeamId headcount from that roster — Engineering: Ryan Mitchell,
// Rachel Turner, Michael Chen, Natalie Brooks, Fatima Al-Sayed (5); Sales:
// Sarah Johnson, Emma Williams, Wei Zhang (3); Customer Support: David Kim,
// Carlos Martinez, James Wilson, Lucas Rodriguez (4). Several of these
// people also hold a *secondary* team via `teamIds` (e.g. Rachel Turner is
// also on Sales, Fatima Al-Sayed is on all three) but are only counted once
// here, against their `activeTeamId`, so the 3 counts sum to exactly 12.
export const DEMO_COMPANY_OPTIONS = [
  { value: 'demo-company', label: 'Meridian Labs' },
];

export const DEMO_TEAM_ROWS = [
  {
    teamId: 'demo-team-engineering',
    teamName: 'Engineering',
    memberCount: 5,
    _loading: false,
  },
  {
    teamId: 'demo-team-sales',
    teamName: 'Sales',
    memberCount: 3,
    _loading: false,
  },
  {
    teamId: 'demo-team-support',
    teamName: 'Customer Support',
    memberCount: 4,
    _loading: false,
  },
];
